import React, { useState } from 'react';
import { MdAdd, MdEdit, MdSettings, MdDevices, MdSearch, MdVisibility } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import ViewDetailsModal from './ViewDetailsModal';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../styles/views.css';

const DevicesView = ({
  pagedFilteredData,
  deviceSearchTerm,
  setDeviceSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddDeviceModalOpen,
  setEditDevice,
  setIsEditDeviceModalOpen,
  loading,
}) => {
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewDevice, setViewDevice] = useState(null);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return { bg: '#e8f5e8', color: '#2e7d32' };
      case 'inactive':
        return { bg: '#ffebee', color: '#c62828' };
      case 'maintenance':
        return { bg: '#fff3cd', color: '#856404' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };

  return (
    <>
      {/* Header Section */}
      <div style={{
        marginBottom: 24,
        padding: '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdDevices size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Device Management
            </h3>
          </div>

          <button
            onClick={() => setIsAddDeviceModalOpen(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: '600',
              boxShadow: '0 2px 4px rgba(25, 118, 210, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#1565c0';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(25, 118, 210, 0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#1976d2';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(25, 118, 210, 0.3)';
            }}
          >
            <MdAdd size={18} />
            Add New Device
          </button>
        </div>

        {/* Search Controls */}
        <div style={{ position: 'relative', maxWidth: 400 }}>
          <MdSearch size={20} style={{
            position: 'absolute',
            left: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666'
          }} />
          <input
            type="text"
            placeholder="Search devices by serial, status, or assigned user..."
            value={deviceSearchTerm}
            onChange={e => setDeviceSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px 10px 40px',
              borderRadius: 8,
              border: '1px solid #ddd',
              fontSize: 14,
              outline: 'none',
              transition: 'border-color 0.2s ease',
              boxSizing: 'border-box'
            }}
            onFocus={e => e.target.style.borderColor = '#1976d2'}
            onBlur={e => e.target.style.borderColor = '#ddd'}
          />
        </div>
      </div>
      {/* Devices Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: '1px solid #f0f0f0',
          overflow: 'hidden'
        }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{
                    padding: '16px 20px',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#333',
                    borderBottom: '2px solid #e9ecef',
                    fontSize: '14px'
                  }}>Serial Number</th>
                  <th style={{
                    padding: '16px 20px',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#333',
                    borderBottom: '2px solid #e9ecef',
                    fontSize: '14px'
                  }}>Status</th>
                  <th style={{
                    padding: '16px 20px',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#333',
                    borderBottom: '2px solid #e9ecef',
                    fontSize: '14px'
                  }}>Assigned User</th>
                  <th style={{
                    padding: '16px 20px',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#333',
                    borderBottom: '2px solid #e9ecef',
                    fontSize: '14px'
                  }}>MMDA</th>
       
                  <th style={{
                    padding: '16px 20px',
                    textAlign: 'center',
                    fontWeight: '600',
                    color: '#333',
                    borderBottom: '2px solid #e9ecef',
                    fontSize: '14px'
                  }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pagedFilteredData.map((row, i) => {
                  const statusColors = getStatusColor(row.status);
                  return (
                    <tr
                      key={i}
                      style={{
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background-color 0.2s ease',
                      }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <td style={{
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#333',
                        fontWeight: '500'
                      }}>{row.device_serial}</td>
                      <td style={{ padding: '16px 20px' }}>
                        <span style={{
                          padding: '6px 12px',
                          backgroundColor: statusColors.bg,
                          color: statusColors.color,
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '600',
                          textTransform: 'capitalize'
                        }}>
                          {row.status || 'Unknown'}
                        </span>
                      </td>
                      <td style={{
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#666'
                      }}>{row.assigned_user_name || 'Unassigned'}</td>
                      <td style={{
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#666'
                      }}>{row.mmda_name || 'N/A'}</td>
<td style={{
                        padding: '16px 20px',
                        textAlign: 'center'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                          <button
                            onClick={() => {
                              setEditDevice(row);
                              setIsEditDeviceModalOpen(true);
                            }}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#1976d2',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4,
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.backgroundColor = '#1565c0';
                              e.currentTarget.style.transform = 'translateY(-1px)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.backgroundColor = '#1976d2';
                              e.currentTarget.style.transform = 'translateY(0)';
                            }}
                            title="Edit Device"
                          >
                            <MdEdit size={14} />
                            Edit
                          </button>

                          <button
                            onClick={() => {
                              // For devices, we can use the current row data as it already has all the info
                              setViewDevice(row);
                              setIsViewModalOpen(true);
                            }}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#4caf50',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4,
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.backgroundColor = '#388e3c';
                              e.currentTarget.style.transform = 'translateY(-1px)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.backgroundColor = '#4caf50';
                              e.currentTarget.style.transform = 'translateY(0)';
                            }}
                            title="View Details"
                          >
                            <MdVisibility size={14} />
                            View
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </TableLoadingWrapper>

      {/* Enhanced Pagination */}
      {pageCount > 1 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 24,
          padding: '20px',
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: '1px solid #f0f0f0'
        }}>
          <ReactPaginate
            previousLabel={'← Previous'}
            nextLabel={'Next →'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
          />
        </div>
      )}

      {/* View Details Modal */}
      <ViewDetailsModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        data={viewDevice}
        type="device"
        title="Device Details"
      />
    </>
  );
};

export default DevicesView;